import _defineProperty from"@babel/runtime/helpers/esm/defineProperty";function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly){symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});}keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(Object(source),true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(Object(source)).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}/**
 * DOM Element selector
 *
 * @param {String|HTMLElement} element - html tag | html element
 *
 * @returns {HTMLElement} - selected html element
 */var select=function select(element){return typeof element==="string"?document.querySelector(element):element();};/**
 * Create new element or Edit existing element
 *
 * @param {String|HTMLElement} tag - html tag | html element
 * @param {Object} options - of the html element
 *
 * @returns {HTMLElement} - created html element
 */var create=function create(tag,options){var el=typeof tag==="string"?document.createElement(tag):tag;for(var key in options){var val=options[key];if(key==="inside"){val.append(el);}else if(key==="dest"){select(val[0]).insertAdjacentElement(val[1],el);}else if(key==="around"){var ref=val;ref.parentNode.insertBefore(el,ref);el.append(ref);if(ref.getAttribute("autofocus")!=null)ref.focus();}else if(key in el){el[key]=val;}else{el.setAttribute(key,val);}}return el;};/**
 * Get the "input" query value
 *
 * @param {Element} field - input or textarea element
 *
 * @returns {String} - Raw query value as a string
 */var getQuery=function getQuery(field){return field instanceof HTMLInputElement||field instanceof HTMLTextAreaElement?field.value:field.innerHTML;};/**
 * Format input value
 *
 * @param {String} value - user's raw search query value
 * @param {Object} diacritics - formatting on/off
 *
 * @returns {String} - Raw "input" value as a string
 */var format=function format(value,diacritics){value=String(value).toLowerCase();return diacritics?value.normalize("NFD").replace(/[\u0300-\u036f]/g,"").normalize("NFC"):value;};/**
 * Debouncer
 *
 * @param {Function} callback - Callback function
 * @param {Number} duration - Delay time value
 *
 * @returns {Function} - Debouncer function
 */var debounce=function debounce(callback,duration){var timer;return function(){clearTimeout(timer);timer=setTimeout(function(){return callback();},duration);};};/**
 * Trigger condition validator
 *
 * @param {String} query - User's manipulated search query value
 * @param {Function} condition - trigger condition rule
 * @param {Number} threshold - of query length to trigger
 *
 * @returns {Boolean} - For autoComplete.js to run or not
 */var checkTrigger=function checkTrigger(query,condition,threshold){return condition?condition(query):query.length>=threshold;};/**
 * Highlight matching characters
 *
 * @param {String} value - user's raw search query value
 * @param {String} cls - of highlighted character
 *
 * @returns {HTMLElement} - newly create html element
 */var mark=function mark(value,cls){return create("mark",_objectSpread({innerHTML:value},typeof cls==="string"&&{class:cls})).outerHTML;};export{select,create,getQuery,format,debounce,checkTrigger,mark};